/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_R2_Upload_PathInputs */

const en_admin_settings_fields_r2_upload_path = /** @type {(inputs: Admin_Settings_Fields_R2_Upload_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Path`)
};

/**
* | output |
* | --- |
* | "Upload Path" |
*
* @param {Admin_Settings_Fields_R2_Upload_PathInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_r2_upload_path = /** @type {((inputs?: Admin_Settings_Fields_R2_Upload_PathInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_R2_Upload_PathInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_r2_upload_path(inputs)
});
export { admin_settings_fields_r2_upload_path as "admin.settings.fields.r2_upload_path" }